/* NEO Store — interacciones de conversión (sin dependencias) */
(() => {
  // 1. Barra fija: aparece cuando el primer botón de compra sale de la pantalla
  const sticky = document.querySelector('[data-neo-sticky]');
  if (sticky) {
    sticky.hidden = false;
    document.body.classList.add('neo-has-sticky');
    const firstBuy = document.querySelector('.neo-buy [data-neo-buy], product-form');
    const show = (v) => sticky.classList.toggle('is-visible', v);
    if (firstBuy && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => show(!e.isIntersecting && e.boundingClientRect.top < 0))
        .observe(firstBuy);
    } else {
      addEventListener('scroll', () => show(scrollY > 500), { passive: true });
    }
  }

  // 1b. Botón real de Releasit (COD): mismo selector que usa su propio script.
  // Todo botón de "comprar"/"checkout" debe abrir este flujo, nunca el checkout
  // nativo de Shopify (que muestra PayPal/tarjeta y cobra flete aparte).
  const findReleasitBuyButton = () =>
    document.getElementById('rsi_buy_now_button') || document.querySelector('.rsi-buy-now-button');

  // Releasit pinta su botón 2–3 s antes de estar listo y un clic temprano se pierde
  // sin aviso: se reintenta cada 500 ms hasta que aparece el formulario (máx ~20 s).
  let abriendo = null;
  const abrirFormulario = () => {
    findReleasitBuyButton()?.click();
    if (abriendo || document.getElementById('rsi_form_wrapper')) return;
    let tries = 0;
    abriendo = setInterval(() => {
      if (document.getElementById('rsi_form_wrapper') || ++tries > 40) {
        clearInterval(abriendo); // ponytail: sin formulario en ~20s se queda la página del producto
        abriendo = null;
        return;
      }
      findReleasitBuyButton()?.click();
    }, 500);
  };

  // 1c. Intercepta cualquier botón nativo "Finalizar compra" (carrito y notificación
  // de "agregado al carrito") para que use el botón COD de Releasit en su lugar.
  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest('button[name="checkout"]');
      if (!btn) return;
      const rsi = findReleasitBuyButton();
      if (rsi) {
        e.preventDefault();
        e.stopPropagation();
        rsi.click();
      }
    },
    true,
  );

  // 2. Sincroniza los enlaces "Comprar automático" con la variante y cantidad elegidas
  const productForm = document.querySelector('product-info product-form, product-form');
  const buildUrl = (href, variantId, qty) => {
    const u = new URL(href, location.origin);
    u.pathname = u.pathname.replace(/\/cart\/\d+:\d+/, `/cart/${variantId}:${qty}`);
    return u.pathname + u.search;
  };
  const syncBuyLinks = () => {
    // Dawn reemplaza el formulario al cambiar de variante: se busca de nuevo cada vez
    const form = document.querySelector('product-info product-form, product-form');
    if (!form) return;
    const idInput = form.querySelector('input[name="id"]');
    const qtyInput = document.querySelector('quantity-input input[name="quantity"]');
    if (!idInput || !idInput.value) return;
    const qty = Math.max(1, parseInt(qtyInput?.value || '1', 10));
    document.querySelectorAll('[data-neo-buy]').forEach((a) => {
      a.setAttribute('href', buildUrl(a.getAttribute('href'), idInput.value, qty));
    });
    document.querySelectorAll('[data-neo-offer]').forEach((a) => {
      a.setAttribute('href', buildUrl(a.getAttribute('href'), idInput.value, a.dataset.qty));
    });
  };
  if (productForm) {
    document.addEventListener('change', () => setTimeout(syncBuyLinks, 60));
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, () => setTimeout(syncBuyLinks, 60));
    }
  }
  // El href de /cart/{id}:{qty} queda como respaldo (sin JS); con JS, "Comprar
  // automático" abre el formulario COD de Releasit en vez de ir al checkout nativo.
  // En páginas sin botón de Releasit (home) el clic lleva a la página del producto
  // con ?pedir=1, que abre el formulario COD sola (ver más abajo).
  document.querySelectorAll('[data-neo-buy]').forEach((a) => {
    a.addEventListener('click', (e) => {
      // Con selector de ofertas, la barra fija primero lleva a elegir la oferta
      const pick = document.querySelector('[data-neo-pick]');
      if (pick && a.closest('[data-neo-sticky]')) {
        const r = pick.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) {
          e.preventDefault();
          pick.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
      }
      const rsi = findReleasitBuyButton();
      if (rsi) {
        e.preventDefault();
        abrirFormulario();
      } else if (a.dataset.productUrl) {
        e.preventDefault();
        location.href = `${a.dataset.productUrl}${'choose' in a.dataset ? '#ofertas' : '?pedir=1'}`;
      }
    });
  });

  // 2b. Selector de ofertas en tarjetas: marca la variante real en el selector de Dawn
  // (oculto) para que el formulario COD pida exactamente esa oferta. Delegado: Dawn
  // puede volver a pintar el bloque al cambiar de variante.
  document.addEventListener('click', (e) => {
    const card = e.target.closest('[data-neo-pick-value]');
    if (!card) return;
    const group = card.closest('[data-neo-pick]');
    const scope = group.closest('.product__info-container') || document;
    const input = [...scope.querySelectorAll('variant-selects input[type="radio"]')]
      .find((i) => i.value === card.dataset.neoPickValue);
    if (input && !input.checked) input.click();
    group.querySelectorAll('[data-neo-pick-value]').forEach((c) => {
      c.classList.toggle('is-active', c === card);
      c.setAttribute('aria-checked', c === card ? 'true' : 'false');
    });
  });

  // Llegada desde la home con ?pedir=1: espera a que Releasit cargue y abre el formulario.
  if (new URLSearchParams(location.search).get('pedir') === '1') {
    history.replaceState(null, '', location.pathname);
    abrirFormulario();
  }

  // 3. Cuenta regresiva hacia una fecha real; se oculta si no hay fecha o ya pasó
  document.querySelectorAll('[data-neo-countdown]').forEach((el) => {
    const end = new Date(el.dataset.neoCountdown).getTime();
    const out = el.querySelector('[data-neo-countdown-time]');
    if (!end || Number.isNaN(end)) return;
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const s = Math.floor((end - Date.now()) / 1000);
      if (s <= 0) { el.hidden = true; return false; }
      const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600);
      const m = Math.floor((s % 3600) / 60), sec = s % 60;
      out.textContent = (d ? `${d}d ` : '') + `${pad(h)}:${pad(m)}:${pad(sec)}`;
      el.hidden = false;
      return true;
    };
    if (tick()) { const t = setInterval(() => { if (!tick()) clearInterval(t); }, 1000); }
  });

  // 3b. Autocompletado de Provincia en el formulario COD de Releasit: su campo es
  // texto libre (sin dropdown propio), así que le agregamos un <datalist> nativo
  // con las 32 provincias oficiales de RD para que se puedan buscar/seleccionar.
  // ponytail: Ciudad se deja como texto libre — poblarla a ciegas (sin el catálogo
  // real de Effi) podría dar nombres que no coinciden con Effi igual; falta traer
  // ese catálogo desde effi.com.co para hacer lo mismo con Ciudad.
  const RD_PROVINCIAS = [
    'Distrito Nacional', 'Azua', 'Baoruco', 'Barahona', 'Dajabón', 'Duarte',
    'Elías Piña', 'El Seibo', 'Espaillat', 'Hato Mayor', 'Hermanas Mirabal',
    'Independencia', 'La Altagracia', 'La Romana', 'La Vega',
    'María Trinidad Sánchez', 'Monseñor Nouel', 'Monte Cristi', 'Monte Plata',
    'Pedernales', 'Peravia', 'Puerto Plata', 'Samaná', 'San Cristóbal',
    'San José de Ocoa', 'San Juan', 'San Pedro de Macorís', 'Sánchez Ramírez',
    'Santiago', 'Santiago Rodríguez', 'Santo Domingo', 'Valverde',
  ];
  const attachProvinceDatalist = () => {
    const input = document.querySelector('input[placeholder="Provincia"]:not([data-neo-ac])');
    if (!input) return;
    input.dataset.neoAc = '1';
    let dl = document.getElementById('neo-provincias-list');
    if (!dl) {
      dl = document.createElement('datalist');
      dl.id = 'neo-provincias-list';
      dl.innerHTML = RD_PROVINCIAS.map((p) => `<option value="${p}"></option>`).join('');
      document.body.appendChild(dl);
    }
    input.setAttribute('list', 'neo-provincias-list');
  };
  new MutationObserver(attachProvinceDatalist).observe(document.body, { childList: true, subtree: true });

  // 3c. Textos del formulario COD de Releasit: vienen en inglés / español de España
  // y su panel de edición no se deja automatizar, así que los reemplazamos aquí.
  // Es idempotente (solo cambia si encuentra el texto original) y limitado al formulario.
  const FORM_TEXTOS = [
    ['Enter your shipping address', '¿A dónde te lo llevamos?'],
    ['Shipping method', 'Método de envío'],
    ['PAGO CONTRA REEMBOLSO', 'PAGAS AL RECIBIR'],
    ['COMPLETA TU COMPRA', 'CONFIRMAR PEDIDO · PAGAS AL RECIBIR'],
    ['Nombre de pila', 'Nombre'],
  ];
  const FORM_EXACTOS = { Shipping: 'Envío', Free: 'Gratis', 'This field is required.': 'Falta este dato' };
  let formPendiente = false;
  const traducirFormulario = () => {
    formPendiente = false;
    const wrap = document.getElementById('rsi_form_wrapper');
    if (!wrap) return;
    const walker = document.createTreeWalker(wrap, NodeFilter.SHOW_TEXT);
    for (let n = walker.nextNode(); n; n = walker.nextNode()) {
      const t = n.nodeValue.trim();
      if (!t) continue;
      if (FORM_EXACTOS[t]) { n.nodeValue = n.nodeValue.replace(t, FORM_EXACTOS[t]); continue; }
      for (const [a, b] of FORM_TEXTOS) {
        if (n.nodeValue.includes(a)) n.nodeValue = n.nodeValue.replace(a, b);
      }
    }
    wrap.querySelectorAll('input[placeholder]').forEach((i) => {
      if (i.placeholder === 'Nombre de pila') i.placeholder = 'Nombre';
      if (i.placeholder === 'Teléfono') i.placeholder = 'Teléfono / WhatsApp (ej. 809 555 1234)';
    });
    // Releasit no pone autocomplete: sin esto el móvil no ofrece autollenar nombre/teléfono/dirección.
    const AUTOCOMPLETE = { first_name: 'given-name', last_name: 'family-name', phone: 'tel', address: 'street-address', province: 'address-level1', city: 'address-level2' };
    for (const [name, ac] of Object.entries(AUTOCOMPLETE)) {
      const i = wrap.querySelector(`input[name="${name}"]`);
      if (i && !i.autocomplete) i.autocomplete = ac;
    }
    // Línea de confianza bajo "¿A dónde te lo llevamos?" (una sola vez).
    if (!wrap.querySelector('.neo-form-confianza')) {
      const titulo = [...wrap.querySelectorAll('*')].find((e) => e.children.length === 0 && e.textContent.trim() === '¿A dónde te lo llevamos?');
      if (titulo) {
        const p = document.createElement('p');
        p.className = 'neo-form-confianza';
        p.textContent = 'No pagas nada ahora · Te confirmamos por WhatsApp antes de enviar';
        p.style.cssText = 'margin:4px 0 8px;text-align:center;font-size:13px;color:#15803d;font-weight:600';
        titulo.insertAdjacentElement('afterend', p);
      }
    }
  };
  new MutationObserver(() => {
    if (formPendiente) return;
    formPendiente = true;
    requestAnimationFrame(traducirFormulario);
  }).observe(document.body, { childList: true, subtree: true, characterData: true });

  // 4. Burbuja de WhatsApp a los 25 s (una vez por sesión)
  const bubble = document.querySelector('[data-neo-wa-bubble]');
  if (bubble) {
    let seen = false;
    try { seen = sessionStorage.getItem('neo-wa') === '1'; } catch (e) {}
    if (!seen) {
      setTimeout(() => {
        bubble.hidden = false;
        try { sessionStorage.setItem('neo-wa', '1'); } catch (e) {}
        setTimeout(() => { bubble.hidden = true; }, 9000);
      }, 25000);
    }
  }
})();
